type Props = {
  calories: number;
  proteinG: number;
  caloriesGoal: number;
  proteinGoalG: number;
  mealCount: number;
};

export function TodayRings({ calories, proteinG, caloriesGoal, proteinGoalG, mealCount }: Props) {
  return (
    <div className="rings">
      <Ring
        label="Calories"
        value={calories}
        goal={caloriesGoal}
        unit="kcal"
        color="var(--accent-cal)"
      />
      <Ring
        label="Protein"
        value={proteinG}
        goal={proteinGoalG}
        unit="g"
        color="var(--accent-pro)"
      />
      <div className="ring-stat">
        <div className="big">{mealCount}</div>
        <div className="small">meal{mealCount === 1 ? "" : "s"}</div>
      </div>
    </div>
  );
}

function Ring({
  label,
  value,
  goal,
  unit,
  color,
}: {
  label: string;
  value: number;
  goal: number;
  unit: string;
  color: string;
}) {
  const pct = Math.min(1, value / Math.max(goal, 1));
  const r = 60;
  const c = 2 * Math.PI * r;
  const dash = c * pct;
  return (
    <div className="ring">
      <svg viewBox="0 0 160 160" width="160" height="160">
        <circle cx="80" cy="80" r={r} className="ring-bg" />
        <circle
          cx="80"
          cy="80"
          r={r}
          stroke={color}
          strokeWidth="14"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={`${dash} ${c}`}
          transform="rotate(-90 80 80)"
        />
        <text x="80" y="76" textAnchor="middle" className="ring-value">
          {Math.round(value)}
        </text>
        <text x="80" y="98" textAnchor="middle" className="ring-goal">
          / {Math.round(goal)} {unit}
        </text>
      </svg>
      <div className="ring-label">{label}</div>
    </div>
  );
}
